import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useScopedPath } from '../../components/ScopedLink';

export default function FormFillThankYou() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const scopedPath = useScopedPath();
  const responseId = params.get('responseId');
  const studentId = params.get('studentId');
  const continueHref = studentId ? `/parent/${studentId}` : scopedPath('/forms');

  return (
    <div
      data-testid="form-thank-you"
      className="mx-auto flex max-w-xl flex-col items-center px-4 py-16 text-center"
    >
      <CheckCircleIcon className="mb-4 h-16 w-16 text-green-500" />
      <h1 className="mb-2 text-2xl font-semibold text-gray-900">Thanks — registration submitted</h1>
      <p className="mb-6 text-gray-600">
        Your child's registration form has been received. You can come back any time to view it from
        your child's profile.
      </p>
      {responseId && (
        <p className="mb-6 font-mono text-xs text-gray-400" data-testid="form-thank-you-ref">
          Ref: {responseId}
        </p>
      )}
      <button
        type="button"
        data-testid="form-thank-you-continue"
        onClick={() => navigate(continueHref)}
        className="rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-500"
      >
        Continue
      </button>
    </div>
  );
}
